import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './LawyerInfoCard.module.scss';

const LawyerInfoCard = ({ infoData }) => {
  const { name, phoneNumber, description } = infoData;
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <div className={classnames(styles.container, isMounted && styles.fadeIn)}>
      <div className={styles.nameWrapper}>
        <p className={styles.nameText}>{name.toUpperCase()}</p>
      </div>
      <div className={styles.phoneWrapper}>
        <p className={styles.phoneLabel}>Phone:&nbsp;</p>
        <a className={styles.link} href={`tel:${phoneNumber}`}>
          <p className={styles.phoneText}>{phoneNumber}</p>
        </a>
      </div>
      <p className={styles.description}>{description}</p>
    </div>
  );
};

LawyerInfoCard.propTypes = {
  infoData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    description: PropTypes.string,
  }).isRequired,
};

export default LawyerInfoCard;
